const getMenuMaxHeight = (targetEl, maxVh = undefined) => {
  if (targetEl) {
    const targetHeight = targetEl.getBoundingClientRect().height;
    return `calc(${maxVh || '50vh'} - ${targetHeight / 2}px)`;
  }
  return 0;
};

const getMenuMaxWidth = (targetEl) => {
  if (targetEl) {
    const targetWidth = targetEl.getBoundingClientRect().width;
    return `calc(50vw - ${targetWidth / 2}px)`;
  }
  return 0;
};

export { getMenuMaxHeight, getMenuMaxWidth };